(function () {
  var bar = document.getElementById('sticky-cart-bar');
  var atcBtn = document.getElementById('scb-atc-btn');
  var qtyInput = bar ? bar.querySelector('.scb-qty-input') : null;
  var mainForm = document.querySelector('form[action="/cart/add"]');

  if (!bar || !mainForm) return;

  var mainAtc = mainForm.querySelector('[type="submit"]');
  function onScroll() {
    if (!mainAtc) { bar.classList.add('is-visible'); return; }
    var rect = mainAtc.getBoundingClientRect();
    if (rect.bottom < 0) {
      bar.classList.add('is-visible');
    } else {
      bar.classList.remove('is-visible');
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  bar.querySelectorAll('.scb-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (btn.dataset.action === 'increase') {
        qtyInput.value = val + 1;
      } else if (val > 1) {
        qtyInput.value = val - 1;
      }
    });
  });

  var mainSelects = mainForm.querySelectorAll('select[name="id"], input[name="id"]');
  mainSelects.forEach(function (el) {
    el.addEventListener('change', function () {
      atcBtn.dataset.variantId = el.value;
    });
  });

  atcBtn.addEventListener('click', function () {
    if (atcBtn.disabled) return;
    var variantId = atcBtn.dataset.variantId;
    var qty = parseInt(qtyInput.value, 10) || 1;
    atcBtn.classList.add('loading');
    atcBtn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        atcBtn.textContent = 'Added ✓';
        setTimeout(function () { atcBtn.textContent = 'Add to cart'; }, 1800);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      })
      .catch(function () {
        atcBtn.textContent = 'Error — try again';
        setTimeout(function () { atcBtn.textContent = 'Add to cart'; }, 2000);
      })
      .finally(function () {
        atcBtn.classList.remove('loading');
      });
  });
})();